__webpack_require__.p = "/correct-effect-size/";